// Pay period utilities — matches backend anchor 2024-01-01 (Monday).
const ANCHOR = new Date('2024-01-01T00:00:00');

function daysBetween(a, b) {
  return Math.floor((a - b) / (24 * 3600 * 1000));
}

export function periodStartFor(date) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const delta = daysBetween(d, ANCHOR);
  const idx = Math.floor(delta / 14);
  const start = new Date(ANCHOR);
  start.setDate(ANCHOR.getDate() + idx * 14);
  return start;
}

export function periodEndFor(date) {
  const s = periodStartFor(date);
  const e = new Date(s);
  e.setDate(s.getDate() + 13);
  return e;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function formatISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseISO(s) {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function formatPretty(date) {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatLong(date) {
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
}

export function dayName(date) {
  return date.toLocaleDateString('en-US', { weekday: 'short' });
}

export function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function currency(n) {
  if (n == null || isNaN(n)) return '$0.00';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
}
